window.onload = function(){
  setTimeout(() => {
    console.log($(".add_to_cart_button, .header-icon-cart"))
    $(".add_to_cart_button, .header-icon-cart").on("click", function(){
      setTimeout(() => {
            console.log(123);
              window.location.href="/cart";
     }, 1000)
    }) 
  }, 100)
}

if(window.location.pathname.includes('/products/')){
  let interval = setInterval(() => {
    // Lấy tất cả các phần tử <td> trong bảng chứa phần trăm giảm giá
    const discountCells = document.querySelectorAll('.bss-b2b-cart-item-qty-table .quantity_break_table td');
    if(discountCells.length){
      clearInterval(interval);
      // Lặp qua từng ô và kiểm tra nếu nó có phần trăm thì thêm ' OFF' sau phần trăm
      discountCells.forEach(cell => {
        if (cell.textContent.includes('%')) {
          // Thêm ' OFF' sau dấu %
          cell.textContent = cell.textContent.replace('%', '% OFF');
        }
      });
    }
  }, 200)

}

if(window.location.pathname.includes('/cart')){
 let setup = () => {
  //   let interval3 = setInterval(() => {
  //   const dc_box = document.querySelector(".bss-b2b-discount-code-wrapper.bss-config-header");
  //   const checkout_btn = document.querySelector("#checkout-submit");
  //   if(dc_box && checkout_btn){
  //      console.log(5);
  //     clearInterval(interval3);
  //     const checkout_btn_wrapper = checkout_btn.closest('div');
  //     if(checkout_btn_wrapper){
  //       checkout_btn_wrapper.after(dc_box);
  //     }
  //   }
  //     setTimeout(() => {
  //        clearInterval(interval3);
  //     }, 5000)
  // }, 100)

  setTimeout(() => {
    let checkout_btn_wrapper = document.querySelector("#checkout-submit").closest('div');
    if(checkout_btn_wrapper){
      checkout_btn_wrapper.insertAdjacentHTML('beforebegin', `
    <div style="display: flex; justify-content: end; margin-bottom: 20px;gap: 20px;">
      <button style="padding: 10px; border: 1px solid #000; background-color: white; cursor: pointer;"
      onclick="window.location.reload();"
      >
        <span style="font-size: 24px;">&#8634;</span>
      </button>
      <button style="padding: 10px; border: 1px solid #000; background-color: white; cursor: pointer;"
      onclick="window.location.href='https://b2b-magicdream.myshopify.com/collections/all'"
      >
        CONTINUE SHOPPING
      </button>
    </div>
      `)
    }
  }, 500)
 }
setup()

  //mutation
  const cart_items = document.querySelector("#main-cart-items");
  if(cart_items){
    const observer = new MutationObserver((MutationList) => {
      console.log("MutationList:", MutationList);
      for(let item of MutationList){
        if(item.target.id === 'main-cart-items'){
          setup()
        }
      }
    })
    observer.observe(cart_items, {childList: true,subtree: true})
  }
  
}

if(window.location.pathname == '/') {
 setTimeout(()=>{
  let appliedDisplayRule = BSS_B2B.td.getAppliedRuleCollectionPage(BSS_B2B, BSS_B2B.shopData);
  BSS_B2B.td.changeCollectionItemVatPriceWithoutCP(BSS_B2B.shopData, appliedDisplayRule)
 },500)
}

setInterval(() => {
  if (window.location.pathname == '/') {
    let appliedDisplayRule = BSS_B2B.td.getAppliedRuleCollectionPage(BSS_B2B, BSS_B2B.shopData);
    BSS_B2B.td.changeCollectionItemVatPriceWithoutCP(BSS_B2B.shopData, appliedDisplayRule)
  }
}, 1000);
